import {createTileLayerLegend} from "base/map";

const routeDensityLegendItems = [
    {color: "#b80600", label: "300+"},
    {color: "#b84d00", label: "60"},
    {color: "#f07f00", label: "30"},
    {color: "#ffe520", label: "15"},
    {color: "#00cc66", label: "6"},
    {color: "#1d9690", label: "1.5"},
];

export const routedensity_01seasonalConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "routedensity_01seasonal",
    legend: createTileLayerLegend({
        layerName: "Cargo",
        layerType: "wms",
        legendItems: routeDensityLegendItems,
    }),
};

export const routedensity_02seasonalConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "routedensity_02seasonal",
    legend: createTileLayerLegend({
        layerName: "Fishing",
        layerType: "wms",
        legendItems: routeDensityLegendItems,
    }),
};

export const routedensity_03seasonalConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "routedensity_03seasonal",
    legend: createTileLayerLegend({
        layerName: "Passenger",
        layerType: "wms",
        legendItems: routeDensityLegendItems,
    }),
};

export const routedensity_04seasonalConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "routedensity_04seasonal",
    legend: createTileLayerLegend({
        layerName: "Tanker",
        layerType: "wms",
        legendItems: routeDensityLegendItems,
    }),
};

export const routedensity_05seasonalConfig = {
    urlTemplate:
        "https://ows.emodnet-humanactivities.eu/wms?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
    format: "image/png",
    opacity: 0.5,
    otherLayerOptions: {},
    layers: "routedensity_05seasonal",
    legend: createTileLayerLegend({
        layerName: "Other",
        layerType: "wms",
        legendItems: routeDensityLegendItems,
    }),
};
